import React, {useState} from "react";
import {Link} from "react-router-dom";
import {Button, Card, FormControl, InputGroup} from "react-bootstrap";
import {getTranslation, translations} from '../settings/translations/list'
import Translate from "../../utils/utils";
import {useIntl} from "react-intl";

export default function Settings() {
    const flowerItems = ['flower', 'variety'];
    const intl = useIntl();
    const [moduleNames, setModuleItems] = useState(translations().concat(flowerItems));
    const transformForDisplay = (moduleName) => {
        return intl.formatMessage({id: getTranslation(moduleName)});
    }

    const handleChange = (e) => {
        const {target: {value}} = e;
        setModuleItems(translations().concat(flowerItems).filter(moduleName => transformForDisplay(moduleName).toLowerCase().search(value.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1").toLowerCase()) !== -1));
    }

    return (
        <>
            <InputGroup className="mb-3">
                <FormControl
                    placeholder={intl.formatMessage({id: "SEARCH.SEARCH"})}
                    className="col-lg-12"
                    onChange={handleChange}
                />
                <InputGroup.Append>
                    <Button variant="outline-secondary">
                        <i className="fa fa-search ml-sm-2" style={{"fontSize": ".7rem"}}/>
                    </Button>
                </InputGroup.Append>
            </InputGroup>

            <div className="row">
                {moduleNames.map((moduleName, key) => {
                    return (
                        <div className="col-sm-3 mb-2" key={key}>
                            <Card>
                                <Card.Body>
                                    <Card.Title
                                        style={{
                                            color: "#380628",
                                            fontSize: "1rem"
                                        }}>{transformForDisplay(moduleName)}</Card.Title>
                                    <Link to={`/settings/${moduleName}`} className="btn btn-success p-1 pull-right"
                                          style={{fontSize: ".9rem"}}
                                    >
                                        <Translate id="DASHBOARD.BUTTON.VIEW_ALL"/>
                                    </Link>
                                </Card.Body>
                            </Card>
                        </div>
                    );
                })}
            </div>
        </>
    );
}